<template>
  <div class='transfer-page'>
    <section class='transfer-header'>
      <div class='transfer-title'>
        <span class='transfer-kicker'>签约管理</span>
        <h1>红人转组</h1>
        <p>选择签约红人并调整归属部门/组，提交后可在记录中查看流转明细</p>
      </div>
      <div class='transfer-status-card'>
        <span>当前红人</span>
        <strong>{{ selectedArtistName }}</strong>
      </div>
    </section>

    <section class='transfer-content'>
      <div class='transfer-layout'>
        <section class='transfer-panel transfer-form-panel'>
          <div class='panel-header'>
            <div>
              <h2>转组信息</h2>
              <p>检索红人后选择新的部门/组</p>
            </div>
          </div>

          <el-form ref='elForm' class='transfer-form' size='small' :model='formData' :rules='rules' label-position='top'>
            <el-form-item label='红人昵称' prop='nickname'>
              <span
                v-if='hasPresetArtist'
                class='transfer-control preset-artist-display'>
                <i class='el-icon-user'></i>
                {{ formData.nickname }}
              </span>
              <artist-search
                v-else
                class='transfer-control'
                :trigger-on-focus='false'
                @handleSelect='handleSelectArtist'></artist-search>
            </el-form-item>
            <el-form-item label='转入部门/组' prop='group_id'>
              <CompanyCascader ref='refCompanySingleCascader' class='transfer-control' @handleSelect='selectDept' />
            </el-form-item>
            <el-form-item class='submit-item'>
              <el-button
                type='primary'
                icon='el-icon-check'
                @click='submitForm'
                v-if="userPermissions.indexOf('sign_transfer_group') > -1">
                确认转组
              </el-button>
            </el-form-item>
          </el-form>
        </section>

        <aside class='transfer-panel transfer-summary-panel'>
          <div class='panel-header'>
            <div>
              <h2>选择概览</h2>
              <p>提交前确认红人和转入组</p>
            </div>
          </div>
          <div class='summary-list'>
            <div class='summary-item'>
              <span>红人昵称</span>
              <strong>{{ selectedArtistName }}</strong>
            </div>
            <div class='summary-item'>
              <span>转入部门/组</span>
              <strong>{{ selectedGroupName }}</strong>
            </div>
            <div class='summary-tip'>
              <i class='el-icon-info'></i>
              <span>确认转组后，将刷新下方转组记录。</span>
            </div>
          </div>
        </aside>
      </div>

      <section class='transfer-panel transfer-record-panel'>
        <div class='panel-header'>
          <div>
            <h2>转组记录</h2>
            <p>{{ recordDescription }}</p>
          </div>
          <el-button
            v-if='formData.artist_id'
            type='text'
            icon='el-icon-refresh'
            @click='showGroupsList'>
            刷新
          </el-button>
        </div>

        <TransferRecord
          v-if='formData.artist_id'
          ref='refArtistGroupsList'
          :artist-id='formData.artist_id'
          :detail-mode='true'
          :key='formData.artist_id'></TransferRecord>

        <div v-else class='record-empty'>
          <i class='el-icon-user'></i>
          <strong>请先选择红人</strong>
          <span>选择红人后，这里会显示对应的转组记录。</span>
        </div>
      </section>
    </section>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import ArtistSearchCustom from '@/components/artist/ArtistSearchCustom'
import SignArtistSearchCustom from '@/components/artist/SignArtistSearchCustom'
import CompanyCascader from '@/components/dept/CompanyCascader'
import ArtistSearch from '@/components/artist/ArtistSearch'
import TransferRecord from '@/pages/sign_info/components/TransferRecord.vue'

export default {
  name: 'TransferGroup',
  components: {
    TransferRecord,
    ArtistSearch,
    CompanyCascader,

    ArtistSearchCustom,
    SignArtistSearchCustom
  },
  props: [],
  data() {
    return {
      formData: {
        kolId: null,
        nickname: null,
        artist_id: null,
        group_id: null,
        group_name: null,
        sign_id: null,
        id: null
      },
      rules: {
        nickname: [{
          required: true,
          message: '请检索并选择转组红人',
          trigger: 'change'
        }],
        group_id: [{
          required: true,
          message: '请选择转入部门-组',
          trigger: 'change'
        }]
      },
      showMore: false
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
    hasPresetArtist() {
      const query = this.$route.query || {}
      return Boolean(query.artist_id || query.id)
    },
    selectedArtistName() {
      return this.formData.nickname || '未选择'
    },
    selectedGroupName() {
      return this.formData.group_name || '未选择'
    },
    recordDescription() {
      return this.formData.artist_id ? `${this.formData.nickname || '-'} 的历史转组记录` : '选择红人后查看历史转组记录'
    }
  },
  watch: {
    '$route.query': {
      handler() {
        this.initRouteArtist()
      },
      deep: true
    }
  },
  created() {
    this.initRouteArtist()
  },
  mounted() {
  },
  methods: {
    initRouteArtist() {
      const query = this.$route.query || {}
      const artistId = query.artist_id || query.id
      if (!artistId) {
        this.formData.artist_id = null
        this.formData.nickname = null
        return
      }

      this.formData.artist_id = artistId
      this.formData.nickname = query.nickname || ''
    },
    handleSelectArtist(obj) {
      if (obj && obj.id) {
        this.formData.artist_id = obj.id
        this.formData.nickname = obj.nickname
        // this.showGroupsList()
      } else {
        this.formData.artist_id = null
        this.formData.nickname = null
      }
    },
    showGroupsList() {
      if (this.$refs['refArtistGroupsList'])
        this.$refs['refArtistGroupsList'].handleQuery()
    },
    submitForm() {
      this.$refs['elForm'].validate(valid => {
        if (!valid) return
        const msg = `此操作将把红人『${this.formData.nickname}』转到【${this.formData.group_name}】, 是否继续?`
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.commitSave()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      })
    },
    async commitSave() {
      if (!(this.formData.artist_id && this.formData.group_id)) {
        this.$notify.warning('红人和新组必选')
        return
      }
      const info = await this.$api.signInfoGroupTransfer(this.formData.artist_id, this.formData.group_id)
      if (info === 'ok') {
        this.$notify.success('转组成功')
        this.showGroupsList()
      }
    },
    selectDept(val) {
      const selected = Array.isArray(val) ? val[0] : val
      let groupId = null
      let groupName = null

      if (selected && typeof selected === 'object') {
        groupId = selected.dpt_id || selected.dept_id || selected.id || null
        groupName = selected.name || selected.dept_name || ''
      } else if (selected) {
        groupId = selected
        groupName = this.$refs['refCompanySingleCascader'].getNodeName(groupId)
      }

      this.$set(this.formData, 'group_name', groupName)
      this.$set(this.formData, 'group_id', groupId)
      this.$refs.elForm.validateField('group_id')
    }
  }
}

</script>
<style scoped>
.transfer-page {
  min-height: 100%;
  padding: 14px;
  background: #f5f7fb;
  box-sizing: border-box;
  overflow: auto;
}

.transfer-header,
.transfer-panel {
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.transfer-header {
  min-height: 104px;
  padding: 18px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.transfer-title {
  min-width: 0;
}

.transfer-kicker {
  height: 24px;
  padding: 0 10px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
}

.transfer-title h1 {
  margin: 8px 0 4px;
  color: #172033;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0;
}

.transfer-title p {
  margin: 0;
  color: #7a8494;
  font-size: 13px;
  line-height: 20px;
}

.transfer-status-card {
  min-width: 220px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
}

.transfer-status-card span {
  color: #8a94a6;
  display: block;
  font-size: 12px;
  line-height: 18px;
}

.transfer-status-card strong {
  margin-top: 4px;
  color: #263142;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.transfer-content {
  margin-top: 12px;
}

.transfer-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 12px;
  align-items: stretch;
}

.transfer-panel {
  min-width: 0;
  overflow: hidden;
}

.panel-header {
  min-height: 64px;
  padding: 14px 18px;
  border-bottom: 1px solid #edf1f6;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.panel-header h2 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.panel-header p {
  margin: 2px 0 0;
  color: #8a94a6;
  font-size: 12px;
  line-height: 18px;
}

.panel-header ::v-deep .el-button {
  color: #ff3176;
}

.transfer-form {
  padding: 18px;
  display: grid;
  grid-template-columns: minmax(260px, 400px) minmax(260px, 420px) auto;
  gap: 16px;
  align-items: end;
}

.transfer-form ::v-deep .el-form-item {
  margin-bottom: 0;
}

.transfer-form ::v-deep .el-form-item__label {
  padding-bottom: 7px;
  color: #667085;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.transfer-control {
  width: 100%;
}

.preset-artist-display {
  min-height: 32px;
  padding: 0 12px;
  color: #263142;
  background: #f8fafc;
  border: 1px solid #dbe3ee;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
}

.preset-artist-display i {
  margin-right: 8px;
  color: #ff3176;
  font-size: 15px;
}

.transfer-control ::v-deep .el-input,
.transfer-control ::v-deep .el-cascader,
.transfer-control ::v-deep .el-autocomplete {
  width: 100%;
}

.submit-item {
  min-width: 120px;
}

.submit-item ::v-deep .el-button {
  width: 118px;
}

.summary-list {
  padding: 8px 18px 18px;
}

.summary-item {
  padding: 14px 0;
  border-bottom: 1px solid #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.summary-item span {
  color: #7a8494;
  font-size: 13px;
  flex: 0 0 auto;
}

.summary-item strong {
  min-width: 0;
  color: #263142;
  font-size: 14px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-tip {
  margin-top: 14px;
  padding: 10px 12px;
  color: #667085;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  line-height: 18px;
}

.summary-tip i {
  margin-top: 2px;
  color: #2f7cf6;
  flex: 0 0 auto;
}

.transfer-record-panel {
  margin-top: 12px;
}

.transfer-record-panel ::v-deep .el-table {
  border-left: 0;
  border-right: 0;
}

.transfer-record-panel ::v-deep .el-table th {
  color: #475467;
  background: #f8fafc;
  font-weight: 600;
}

.transfer-record-panel ::v-deep .el-table td,
.transfer-record-panel ::v-deep .el-table th {
  border-color: #edf1f6;
}

.transfer-record-panel ::v-deep .detail-pagination-row {
  padding: 12px 16px;
  border-top: 1px solid #edf1f6;
}

.record-empty {
  min-height: 260px;
  padding: 34px;
  color: #8a94a6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.record-empty i {
  color: #d0d5dd;
  font-size: 50px;
}

.record-empty strong {
  margin-top: 12px;
  color: #344054;
  font-size: 16px;
  line-height: 24px;
}

.record-empty span {
  margin-top: 6px;
  color: #98a2b3;
  font-size: 13px;
  line-height: 20px;
}

@media (max-width: 1180px) {
  .transfer-layout {
    grid-template-columns: 1fr;
  }

  .transfer-form {
    grid-template-columns: repeat(2, minmax(240px, 1fr));
  }
}

@media (max-width: 760px) {
  .transfer-page {
    padding: 12px;
  }

  .transfer-header {
    padding: 18px;
    align-items: flex-start;
    flex-direction: column;
  }

  .transfer-status-card {
    width: 100%;
    min-width: 0;
  }

  .transfer-form {
    grid-template-columns: 1fr;
  }
}
</style>
